import { Col, Form, Row } from "antd";
import React, { Component } from "react";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import { connect } from "react-redux";
import "./free.scss";
const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedFreeEmail extends Component {
  componentDidMount() {
    this.props.openKeyboard();
  }
  

  submitForm = async () => {
    //await this.props.submit();
    this.props.next();
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
    };
    return (
      <div>
        <div>
          <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="email"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Row>
              <Col span={18} style={{ padding: "1.5em" }}>
                <Form.Item
                  //label={<strong>E-mail:</strong>}
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Kérem adja meg az e-mail címét!",
                    },
                    {
                      type: "email",
                      message: "Helytelen formátum!",
                    },
                  ]}
                >
                  <input
                    id="email"
                    name="email"
                    onChange={this.props.change}
                    value={this.props.email}
                    onFocus={this.props.setInputName}
                    style={{ width: "100%" }}
                    className="free-input-field"
                    placeholder="E-mail cím"
                  />
                </Form.Item>
              </Col>
              <Col span={4} style={{ padding: "1.5em" }}>
                <Form.Item>
                  <button type="submit" className="free-next-button">
                    Következő <Right className="free-arrow-icon" />
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Form>          
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const FreeEmail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedFreeEmail);
export default FreeEmail;
